<template>
  <div class="con">
    <!-- 头部 -->
    <headbox></headbox>
    <!-- 内容 -->
    <costoptimizat></costoptimizat>
    <!-- 底部 -->
    <footbox></footbox>
  </div>
</template>

<script>
import headbox from './components/home/headbox' 
import costoptimizat from './components/costoptimizat.vue' 
import footbox from './components/footbox' 
export default {
  components: {
    headbox,
    costoptimizat,
    footbox,
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.img-box {
  height: 318px;
  background: url("../assets/services/banner2.png") no-repeat;
  background-size: cover;
  background-position: center;
}
.img-box-en {
  height: 318px;
  background: url("../assets/en/banner2.jpg") no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
